var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 19C12.411 19 16 15.411 16 11C16 7.64999 13.928 4.77899 11 3.58899V5.81199C11.9109 6.33791 12.6676 7.09405 13.1941 8.00461C13.7207 8.91517 13.9986 9.94815 14 11C14 14.309 11.309 17 8 17C4.691 17 2 14.309 2 11C2.00133 9.94813 2.2792 8.91511 2.80575 8.00453C3.3323 7.09396 4.08901 6.33783 5 5.81199L5 3.58899C2.072 4.77899 0 7.64999 0 11C0 15.411 3.589 19 8 19Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 0L9 0L9 10L7 10L7 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerOff);
export default __webpack_public_path__ + "static/media/power-off.b61d3942a12f5a0b06176892edea181e.svg";
export { ForwardRef as ReactComponent };